import { generalStatuses as phonesOrderStatuses } from '@/constants/phones_constants';

export default {
  data() {
    return {
      useNullablePhonesOrderGeneralStatus: true,
    };
  },
  computed: {
    phonesOrderGeneralStatusItems() {
      const items = [];
      if (this.useNullablePhonesOrderGeneralStatus) {
        items.push({
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        });
      }
      Object.keys(phonesOrderStatuses)
        .forEach((key) => {
          items.push({
            text: this.lang(this.$store, `sap/listings.global.filter.order_statuses.${phonesOrderStatuses[key]}`),
            value: phonesOrderStatuses[key],
          });
        });
      return items;
    },
  },
};
